import getParent from '../selectors';

export const getNullValue = state =>
  getParent(state).nullValue;

export default getNullValue;
